import { AngularEditorConfig } from '@kolkov/angular-editor';

export const TextEditorConfig :AngularEditorConfig = {
  editable: true,
  spellcheck: true,
  placeholder: 'Enter text here...',
  translate: 'no',
  defaultParagraphSeparator: 'p',
  defaultFontName: 'Arial',
  sanitize: false,
  customClasses: [
    {
      name: 'quote',
      class: 'quote',
    },
    {
      name: 'redText',
      class: 'redText',
    },
    {
      name: 'titleText',
      class: 'titleText',
      tag: 'h1',
    },
  ],
};
